// extracted by mini-css-extract-plugin
module.exports = {"appointmentCard":"AppointmentSectionNew_appointmentCard__2s3AK"};